export type DrugCoverageTableGroup = {
  id: string;
  name: string;
  groupCaption: string;
  planComparisonTableHeader: string;
  options: Array<DrugCoverageTableGroupOption>;
};

export type DrugCoverageTableGroupOption = {
  id: string;
  optionName: string;
  caption: string;
  drugCoverageTables: Array<DrugCoverageTable>;
};

export type UsedOption = {
  groupCaption: string;
  planComparisonTableHeader: string;
  drugCoverageTables: Array<DrugCoverageTable>;
};

export type DrugCoverageTable = {
  id: string;
  caption: string;
  columnGroup: DrugCoverageTableColumnGroup;
  rows: Array<DrugCoverageTableRow>;
};

export type DrugCoverageTableColumnGroup = {
  columns: Array<DrugCoverageTableColumn>;
};

export type DrugCoverageTableColumn = {
  color: string;
};

export type DrugCoverageTableRow = {
  isOnPlanComparison: boolean;
  tooltip: string;
  cells: Array<DrugCoverageTableCell>;
};

export type DrugCoverageTableCell = {
  isHeader: boolean;
  label: string;
};
